import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route } from 'react-router-dom'
import { Container, DashboardSubNavs } from '../../components'
import { useInternationalization } from '../../features/i18n'
import { fetchOrganization } from '../../features/organization/slice'
import { useViewport } from '../../utils'
import { ContentGeneral } from './components/content-general.v1'
// import { ContentGeneral } from './components'

const Content = () => {
  return (
    <div className="lg:mb-8">
      <Route path="/dashboard/visibility/event">
        <ContentGeneral fieldKey="event"/>
      </Route>
      <Route path="/dashboard/visibility/resource">
        <ContentGeneral fieldKey="resource"/>
      </Route>
      <Route path="/dashboard/visibility/blog">
        <ContentGeneral fieldKey="blog"/>
      </Route>
      <Route path="/dashboard/visibility" exact>
        <ContentGeneral fieldKey="program"/>
      </Route>
    </div>
  )
}

const DashboardVisibility = () => {
  const dispatch = useDispatch()
  const { isDesktop } = useViewport()
  const { id } = useSelector(state => state.account.profile)
  const { translate } = useInternationalization()

  useEffect(() => {
    dispatch(fetchOrganization(id))
    // eslint-disable-next-line
  }, [])

  const subroutes = [
    {
      label: 'Program',
      route: '/dashboard/visibility',
      exact: true
    },
    {
      label: translate('EVENT', 'singular'),
      route: '/dashboard/visibility/event'
    },
    {
      label: translate('RESOURCE', 'singular'),
      route: '/dashboard/visibility/resource'
    },
    {
      label: 'Blog',
      route: '/dashboard/visibility/blog'
    }
  ]

  return isDesktop ? (
    <>
      <div className="flex items-center mb-10">
        <h1 className="text-4xl font-bold font-primary mr-4">
          {translate('DASHBOARD', 'visibility_settings')}
        </h1>
      </div>
      <DashboardSubNavs links={subroutes}/>
      <Content />
    </>
  ) : (
    <>
      <DashboardSubNavs links={subroutes}/>
      <Container>
        <Content />
      </Container>
    </>
  )
}

export { DashboardVisibility }
